import { MutationTree } from 'vuex';
import { State } from './state';
import {
    SET_PROFILE_LIST,
    SET_REGISTER_PROFILE_FORM_VISIBILITY,
    SET_SELECTED_PROFILE,
    ADD_PROFILE_TO_LIST,
    SET_FLAG_LIST,
    SET_VEHICLE_TYPE_LIST,
    SET_COUNTRY_LIST,
    SET_PROFILE_FUNCTIONALITIES,
    SET_CURRENT_PROFILE_TAB,
} from './types';
import { IProfile } from '../models';
import { IFlag, IVehicleType, ICountry } from '@/models';
import { IFunctionality } from '@/modules/functionality/models';


export const mutations: MutationTree<State> = {
    [SET_PROFILE_LIST](state: State, payload: IProfile[]) {
        state.profiles = payload;
    },
    [SET_REGISTER_PROFILE_FORM_VISIBILITY](state: State, payload: boolean) {
        state.showRegisterForm = payload;
    },
    [SET_SELECTED_PROFILE](state: State, payload: IProfile) {
        state.profileSelected = payload;
    },
    [ADD_PROFILE_TO_LIST](state: State, payload: IProfile) {
        state.profiles.push(payload);
    },
    [SET_FLAG_LIST](state: State, payload: IFlag[]) {
        state.flags = payload;
    },
    [SET_VEHICLE_TYPE_LIST](state: State, payload: IVehicleType[]) {
        state.vehicleTypes = payload;
    },
    [SET_COUNTRY_LIST](state: State, payload: ICountry[]) {
        state.countries = payload;
    },
    [SET_PROFILE_FUNCTIONALITIES](state: State, payload: IFunctionality[]) {
        state.profileSelected.functionalities = payload.map((c) => c.id);
    },
    [SET_CURRENT_PROFILE_TAB](state: State, payload: string) {
        state.currentTab = payload;
    },
};
